import * as React from "react";
import * as ReactDOM from "react-dom";
import { LWPComponent } from "VSSPreview/Flux/Components/LWP";
import { SecurityDialogOptions } from "Admin/Scripts/TFS.Admin.Security";

export interface ResourceSecurityDialogProps extends SecurityDialogOptions {}

export interface ResourceSecurityDialogState {
    viewResourceSecurity: boolean;
}

export function renderResourceSecurityDialogUX(props: SecurityDialogOptions) {
    ReactDOM.render(<ResourceSecurityDialog {...props as ResourceSecurityDialogProps} /> , document.createElement("div"));
}

export class ResourceSecurityDialog extends React.Component<ResourceSecurityDialogProps, ResourceSecurityDialogState> {

    constructor(props: ResourceSecurityDialogProps, context: any) {
        super(props, context);

        this.state = {
            viewResourceSecurity: true
        } as ResourceSecurityDialogState
    }

    public render(): JSX.Element {
        return (
            <div>
                {this.state.viewResourceSecurity &&
                    (<LWPComponent
                        dependencies={["ms.vss-admin-web.security-view-common-content"]}
                        wrappedType="ms.vss-admin-web.security-panel-component"
                        onCancel={this._onSecurityDialogCancel}
                        securityViewTitle={this.props.tokenDisplayVal}
                        permissionSetId={this.props.permissionSet}
                        permissionSetToken={this.props.token}
                    />
                )}
                
            </div>
        );
    }

    private _onSecurityDialogCancel = () => {
        this.setState({
            viewResourceSecurity: false
        });
    };
}
